import { unwrap } from '../http.js';
import { paginate } from '../pagination.js';
export function createFeedApi(client) {
    async function home(query) {
        return unwrap(await client.GET('/v1/feed', { params: { query: query ?? {} } }));
    }
    async function explore(query) {
        return unwrap(await client.GET('/v1/feed/explore', { params: { query: query ?? {} } }));
    }
    return {
        home,
        iterateHome(query) {
            return paginate(home, query);
        },
        explore,
        iterateExplore(query) {
            return paginate(explore, query);
        },
    };
}
//# sourceMappingURL=feed.js.map